import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { reducers as apiHOCs } from 'components/apiHOCs';
import entities from './entities';

export default combineReducers({
	form,
	entities,
	apiHOCs,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js